// ----------------------------------------------------------------------
// <copyright file="Izenda.DeleteButton.jsx" company="Izenda"> Copyright (c)
// 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------
!(function() {
  var React = require('react');
  var PropTypes = React.PropTypes;
  var ObservablePropTypes = require('mobx-react').propTypes;
  var DashboardGridConstants = require('logic/data/Izenda.DashboardGridConstants');

  var connect = require('share/enhancers/Izenda.Connect');

  var DeleteButton = connect()(function(props) {
    var store = props.store;
    var viewMode = props.viewMode;
    var dashboardPart = props.dashboardPart;
    var loader = props.loader;
    var confirmFn = props.confirmFn;

    if (viewMode) {
      return null;
    }

    var deleteDashboardPart = function() {
      loader.startLoading();
      return store.deleteDashboardPart(dashboardPart).finally(loader.endLoading.bind(loader));
    };

    var onDelete = function(e) {
      e.stopPropagation();

      return confirmFn('Information', {
        description: String.format(DashboardGridConstants.DELETE_CONFIRM_MESSAGE, dashboardPart.title)
      }).then(deleteDashboardPart);
    };

    return (
      <a className='btn u_noBorderAll' title={DashboardGridConstants.DELETE_ICON_TOOLTIP} onClick={onDelete}>
        <i className='icon-cancel' />
        {props.showLabel && <span>{DashboardGridConstants.DELETE_ICON_TOOLTIP}</span>}
      </a>
    );
  });

  DeleteButton.propTypes = {
    store: ObservablePropTypes.observableObject.isRequired,
    dashboardPart: ObservablePropTypes.observableObject.isRequired,
    viewMode: PropTypes.bool
  };

  module.exports = DeleteButton;
})();



// WEBPACK FOOTER //
// ./ui/modules/Dashboard/DashboardDesigner/DashboardGrid/DashboardTile/Header/Izenda.DeleteButton.jsx